export function hamburger() {
  const hamburger = document.querySelector('.js-hamburger');
  const hamburger_target = document.querySelector('.js-hamburger--target');
  const body = document.querySelector('body');

  hamburger.addEventListener('click', function () {
    this.classList.toggle('is-active');
    hamburger_target.classList.toggle('is-view');
    body.classList.toggle('is-noscroll');
    if(this.classList.contains('is-active')) {
      menuClose();
    }
  });

  const hamburgerSlides = document.querySelectorAll('.js-hamburgerSlide');
  const hamburgerSlide_top = document.querySelector('.js-hamburgerSlide--top');
  for (let index = 0; index < hamburgerSlides.length; index++) {
    const hamburgerSlide = hamburgerSlides[index];
    
    hamburgerSlide.addEventListener('click', function() {
      let id = this.dataset.target;
      hamburgerSlide_top.classList.remove('is-view');
      let target = document.getElementById(id);
      target.classList.add('is-view');
    });
  }

  const hamburgerSlide_targets = document.querySelectorAll('.js-hamburgerSlide--target');
  const hamburgerSlide_closes = document.querySelectorAll('.js-hamburgerSlide--close');
  for (let index = 0; index < hamburgerSlide_closes.length; index++) {
    const hamburgerSlide_close = hamburgerSlide_closes[index];
    hamburgerSlide_close.addEventListener('click', () => {
      hamburgerSlide_top.classList.add('is-view');
      hamburgerSlide_targets.forEach(target => {
        menuClose();
      });
    })
  }

  const menuClose = () => {
    hamburgerSlide_top.classList.add('is-view');
    hamburgerSlide_targets.forEach(target => {
      target.classList.remove('is-view');
    });
  }
}